// extracted by mini-css-extract-plugin
export default {"modal-header":"style_modal-header__Xymem","modal-header__title":"style_modal-header__title__aRS-n","modal-header__close-button":"style_modal-header__close-button__P10tE"};